import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Card } from '@node-space/ui-components'
import { EarnSummaryItem, EarnSummaryItemVariant } from './EarnSummaryItem'

export interface EarnAssetSummaryDirectProps {
  asset: string
  earnRate: string
  allocatedFunds: string
  myLifetimeEarnings: string
}

export const EarnAssetSummaryDirect = ({
  asset,
  earnRate,
  allocatedFunds,
  myLifetimeEarnings,
}: EarnAssetSummaryDirectProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full borderRadius={12} testId="earn-asset-summary-direct">
      <Box flex gap={24} align="center" className="max-sm:flex-col max-sm:items-start">
        <Box flexCol gap={8} justify="center" className="flex-1 min-w-0">
          <Box flex gap={8} align="center">
            <Avatar type="currency" name={asset} />
            <h2 className="text-h2 text-foreground-prominent">{asset}</h2>
          </Box>
          <p className="text-body-strong text-foreground-prominent">
            {t('earn.currentEarnRate', { rate: earnRate })}
          </p>
        </Box>

        <EarnSummaryItem
          label={t('earn.yourAllocatedFunds')}
          value={allocatedFunds}
          variant={EarnSummaryItemVariant.LARGE}
        />
        <EarnSummaryItem
          label={t('earn.myLifetimeEarnings')}
          value={myLifetimeEarnings}
          variant={EarnSummaryItemVariant.LARGE}
        />
      </Box>
    </Card>
  )
}
